import React from 'react';
import { useGetRecords } from 'root/admin/components/hooks';
import store from '../../store';

import { Column, Loader, Form, Attachments } from '@smartplatform/ui';
import { ModelTable } from '../../components';

const MediaAccretiationList = ({ rootPath, tabName }) => {
	const records = useGetRecords({ model: 'MediaAccreditation', tabName });

	if (!records) {
		return <Loader />;
	}

	const mediaAccreditation = records[0] ? records[0] : new store.model.MediaAccreditation();

	return (
		<div>
			<h3>Аккредитация СМИ при Государственном Собрании (Ил Тумэн) Республики Саха (Якутия)</h3>
			<Form record={mediaAccreditation} stay noSave={records.totalCount !== 0} noDelete>
				<Attachments record={mediaAccreditation} relation="attachments" store={store.model} label="Документы" />
			</Form>
			<h3> Список аккредитованных СМИ</h3>
			<ModelTable
				model="MediaTitle"
				options={{ order: 'name ASC' }}
				rootPath={rootPath}
				path={`${rootPath}/mediatitles`}
				limit={20}
			>
				<Column property="name" label="Название СМИ" />
			</ModelTable>
		</div>
	);
};

export default MediaAccretiationList;
